import React from "react";

const RootCauseTable = ({ data }) => {

  return (
    <div className="bg-gray-800 p-5 rounded-xl border border-gray-700">

      <h3 className="mb-4 font-semibold text-white">
        🔍 Root Cause Breakdown
      </h3>

      <table className="w-full text-sm">

        <thead className="text-gray-400 border-b border-gray-700">
          <tr>
            <th className="text-left py-2">Cause</th>
            <th className="text-left py-2">Count</th>
          </tr>
        </thead>

        <tbody>

          {data.map((d, i) => (
            <tr key={i} className="border-b border-gray-700">
              <td className="py-2">{d.cause}</td>
              <td className="py-2">{d.count}</td>
            </tr>
          ))}

        </tbody>

      </table>

    </div>
  );
};

export default RootCauseTable;